import type { DeliveryRecapItem } from '@/api/receive';
import { PaginationList } from '@/components/layout/PaginationList';

import { UIBox } from '@/components/ui/Box';
import { Typography } from '@/components/ui/Typography';
import ProductListItem from '@/pages/Receiving/PageReceivingRecap/ProductListItem';
import {
  StyledContentInfo,
  StyledUIBox,
} from '@/pages/Receiving/PageReceivingRecap/ProductListItem/style';
import type { ScannedProduct } from '@/types/product';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyledUIList } from './style';

type ProductListProps = {
  data: DeliveryRecapItem[];
  onProductImageClick: (e: React.MouseEvent, upcCode: string) => void;
  hasSubheader?: boolean;
  flowType: string;
};

const ProductList = ({
  data,
  onProductImageClick,
  flowType,
}: ProductListProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <StyledUIList
        rounded={data.length > 0}
        backgrounded={data.length > 0}
        shadowed={data.length > 0}
        title={
          <>
            <Typography font={'light'} size={'sm'}>
              {t('receiving.recapTitle')}
            </Typography>
            <StyledContentInfo
              justifyContent="space-between"
              className={'recap-columns'}
            >
              <StyledUIBox>
                <Typography align={'right'} size={'sm'}>
                  {t('receiving.expectedqty')}
                </Typography>
                <Typography align={'right'} size={'sm'}>
                  {t('receiving.qtysold')}
                </Typography>
                <Typography align={'right'} size={'sm'}>
                  {t('receiving.qtyFound')}
                </Typography>
                <Typography align={'right'} size={'sm'}>
                  {t('receiving.qtytotalfound')}
                </Typography>
                <Typography align={'right'} size={'sm'}>
                  {t('receiving.adj')}
                </Typography>
              </StyledUIBox>
            </StyledContentInfo>
          </>
        }
      >
        <PaginationList
          data={data}
          pageSize={50}
          noItems={
            <UIBox
              display="flex"
              justifyContent="center"
              alignItems="center"
              marginTop="10%"
            >
              <Typography font="heavy" color="grey">
                {t('noItems')}
              </Typography>
            </UIBox>
          }
          renderItem={(productItem: ScannedProduct): JSX.Element => (
            <ProductListItem
              key={productItem.upcCode}
              onProductImageClick={onProductImageClick}
              flowType={flowType}
              {...productItem}
            />
          )}
        />
      </StyledUIList>
    </>
  );
};

export default ProductList;
